export default __webpack_public_path__ + "static/media/banner.8c0c20e4.png";